export const messages = {
  ru: {
    invoice_flow__user_is_registered: 'Пожалуйста, завершите платёж в приложении MuchBetter.',
    invoice_flow__user_is_not_registered:
      'Ваша транзакция ожидает подтверждения, но, похоже, что у вас нет учётной записи.',
    invoice_flow__please_sign_up: 'Перейдите по ссылке для регистрации.',
  },
  uk: {
    invoice_flow__user_is_registered: 'Будь ласка, завершіть платіж у додатку MuchBetter.',
    invoice_flow__user_is_not_registered:
      'Ваша транзакція очікує підтвердження, але, схоже, що у вас немає облікового запису.',
    invoice_flow__please_sign_up: 'Перейдіть за посиланням для реєстрації.',
  },
  en: {
    invoice_flow__user_is_registered: 'Please complete the payment in your MuchBetter App.',
    invoice_flow__user_is_not_registered:
      "Your transaction is pending, but it looks like you don't have an account.",
    invoice_flow__please_sign_up: 'Please sign up.',
  },
};
